import axios from "axios";
import { ref } from "vue";
import { dashboardApiHost } from "@/constants/urls.js";

async function getTeamDonations(teamId, params) {
  const url = `${dashboardApiHost}/orgarea/api/v1/donor_account/logins_to_teams/team/${teamId}/donors`;
  const { data, headers } = await axios.get(url, {
    params: {
      ...params,
    },
  });

  return {
    data,
    count: headers["x-total-records"],
  };
}

async function getSubTeamDonations(teamId, params) {
  const url = `${dashboardApiHost}/orgarea/api/v1/donor_account/logins_to_teams/team/${teamId}/sub-donors`;
  const { data, headers } = await axios.get(url, {
    params: {
      ...params,
    },
  });

  return {
    data,
    count: headers["x-total-records"],
  };
}

export function useTeamDonationList() {
  const loading = ref(false);
  const loadingSub = ref(false);
  const donations = ref([]);
  const donationsTotal = ref(0);
  const subDonations = ref([]);
  const subDonationsTotal = ref(0);

  async function fetchTeamDonations(teamId, params) {
    loading.value = true;

    try {
      const { data, count } = await getTeamDonations(teamId, params);
      donationsTotal.value = count;
      donations.value = data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function fetchSubTeamDonations(teamId, params) {
    loadingSub.value = true;

    try {
      const { data, count } = await getSubTeamDonations(teamId, params);
      subDonationsTotal.value = count;
      subDonations.value = data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loadingSub.value = false;
    }
  }

  return {
    donations,
    donationsTotal,
    subDonations,
    subDonationsTotal,
    loading,
    loadingSub,
    fetchTeamDonations,
    fetchSubTeamDonations,
  };
}
